import React from "react";
import Input from "../atoms/Input.jsx";
import Select from "../atoms/Select.jsx";
import FilterContainer from "../molecules/FilterContainer.jsx";
import { 
  ORGANIZATION_OPTIONS, 
  EC2_STATE_OPTIONS, 
  BOOLEAN_OPTIONS, 
  IAM_STATUS_OPTIONS, 
  BACKUP_STATUS_OPTIONS, 
  AD_STATUS_OPTIONS 
} from "@/config/tableConfig";

const TableFilters = ({ filters, onFilterChange, filterType = "efs" }) => {
  const getFilterFields = () => {
    switch (filterType) {
      case "ec2":
        return [
          {
            key: "organizationName",
            label: "Organization",
            type: "select",
            options: ORGANIZATION_OPTIONS,
          },
          {
            key: "accountId",
            label: "Account ID",
            type: "text",
            placeholder: "Filter by Account ID...",
          },
          {
            key: "accountName",
            label: "Account Name",
            type: "text",
            placeholder: "Filter by Account Name...",
          },
          {
            key: "EC2InstanceId",
            label: "Instance ID",
            type: "text",
            placeholder: "Filter by Instance ID...",
          },
          {
            key: "EC2InstanceName",
            label: "Instance Name",
            type: "text",
            placeholder: "Filter by Instance Name...",
          },
          {
            key: "EC2InstanceType",
            label: "Instance Type",
            type: "text",
            placeholder: "Filter by Instance Type...",
          },
          {
            key: "EC2State",
            label: "State",
            type: "select",
            options: EC2_STATE_OPTIONS,
          },
        ];
      case "s3":
        return [
          {
            key: "organizationName",
            label: "Organization",
            type: "select",
            options: ORGANIZATION_OPTIONS,
          },
          {
            key: "accountId",
            label: "Account ID",
            type: "text",
            placeholder: "Filter by Account ID...",
          },
          {
            key: "accountName",
            label: "Account Name",
            type: "text",
            placeholder: "Filter by Account Name...",
          },
          {
            key: "BucketName",
            label: "Bucket Name",
            type: "text",
            placeholder: "Filter by Bucket Name...",
          },
          {
            key: "BlockPublicAcls",
            label: "Block Public ACLs",
            type: "select",
            options: BOOLEAN_OPTIONS,
          },
          {
            key: "IgnorePublicAcls",
            label: "Ignore Public ACLs",
            type: "select",
            options: BOOLEAN_OPTIONS,
          },
          {
            key: "BlockPublicPolicy",
            label: "Block Public Policy",
            type: "select",
            options: BOOLEAN_OPTIONS,
          },
          {
            key: "RestrictPublicBuckets",
            label: "Restrict Public Buckets",
            type: "select",
            options: BOOLEAN_OPTIONS,
          },
        ];
      case "ad":
        return [
          {
            key: "ObjectName",
            label: "Name",
            type: "text",
            placeholder: "Filter by Name...",
          },
          {
            key: "SamAccountName",
            label: "User Name",
            type: "text",
            placeholder: "Filter by User Name...",
          },
          {
            key: "EmailAddress",
            label: "Email",
            type: "text",
            placeholder: "Filter by Email...",
          },
          {
            key: "Description",
            label: "Description",
            type: "text",
            placeholder: "Filter by Description...",
          },
          {
            key: "Enabled",
            label: "Status",
            type: "select",
            options: AD_STATUS_OPTIONS,
          },
        ];
      case "iam":
        return [
          {
            key: "organizationName",
            label: "Organization",
            type: "select",
            options: ORGANIZATION_OPTIONS,
          },
          {
            key: "accountId",
            label: "Account ID",
            type: "text",
            placeholder: "Filter by Account ID...",
          },
          {
            key: "accountName",
            label: "Account Name",
            type: "text",
            placeholder: "Filter by Account Name...",
          },
          {
            key: "UserId",
            label: "User ID",
            type: "text",
            placeholder: "Filter by User ID...",
          },
          {
            key: "UserName",
            label: "User Name",
            type: "text",
            placeholder: "Filter by User Name...",
          },
          {
            key: "AccessKeyId",
            label: "Access Key",
            type: "text",
            placeholder: "Filter by Access Key...",
          },
          {
            key: "AccessKeyStatus",
            label: "Status",
            type: "select",
            options: IAM_STATUS_OPTIONS,
          },
        ];
      case "rds":
        return [
          {
            key: "organizationName",
            label: "Organization",
            type: "select",
            options: ORGANIZATION_OPTIONS,
          },
          {
            key: "accountId",
            label: "Account ID",
            type: "text",
            placeholder: "Filter by Account ID...",
          },
          {
            key: "accountName",
            label: "Account Name",
            type: "text",
            placeholder: "Filter by Account Name...",
          },
          {
            key: "rdsInstanceId",
            label: "RDS Instance ID",
            type: "text",
            placeholder: "Filter by RDS Instance ID...",
          },
          {
            key: "backupStatus",
            label: "Backup Status",
            type: "select",
            options: BACKUP_STATUS_OPTIONS,
          },
        ];
      case "accounts":
        return [
          {
            key: "organizationName",
            label: "Organization Name",
            type: "select",
            options: ORGANIZATION_OPTIONS,
          },
          {
            key: "organizationalUnitName",
            label: "Organizational Unit",
            type: "text",
            placeholder: "Filter by Organizational Unit...",
          },
          {
            key: "accountId",
            label: "Account ID",
            type: "text",
            placeholder: "Filter by Account ID...",
          },
          {
            key: "accountName",
            label: "Account Name",
            type: "text",
            placeholder: "Filter by Account Name...",
          },
        ];
      case "costs":
        return [
          {
            key: "organizationName",
            label: "Organization Name",
            type: "select",
            options: ORGANIZATION_OPTIONS,
          },
          {
            key: "OpcoName",
            label: "OPCO",
            type: "text",
            placeholder: "Filter by OPCO...",
          },
          {
            key: "accountId",
            label: "Account ID",
            type: "text",
            placeholder: "Filter by Account ID...",
          },
          {
            key: "accountName",
            label: "Account Name",
            type: "text",
            placeholder: "Filter by Account Name...",
          },
          {
            key: "productName",
            label: "Product Name",
            type: "text",
            placeholder: "Filter by Product Name...",
          },
        ];
      case "efs":
      default:
        return [
          {
            key: "organizationName",
            label: "Organization",
            type: "select",
            options: ORGANIZATION_OPTIONS,
          },
          {
            key: "accountId",
            label: "Account ID",
            type: "text",
            placeholder: "Filter by Account ID...",
          },
          {
            key: "accountName",
            label: "Account Name",
            type: "text",
            placeholder: "Filter by Account Name...",
          },
          {
            key: "fileSystemId",
            label: "File System ID",
            type: "text",
            placeholder: "Filter by File System ID...",
          },
          {
            key: "backupStatus",
            label: "Backup Policy Status",
            type: "select",
            options: BACKUP_STATUS_OPTIONS,
          },
        ];
    }
  };

  const filterFields = getFilterFields();

  return (
    <FilterContainer>
      {filterFields.map((field) => (
        <div key={field.key} className="flex flex-col h-full justify-end">
          <label
            htmlFor={field.key}
            className="block text-sm font-medium text-gray-700 mb-2"
          >
            {field.label}
          </label>
          {field.type === "text" ? (
            <Input
              id={field.key}
              type="text"
              value={filters[field.key] || ""}
              onChange={(e) => onFilterChange(field.key, e.target.value)}
              placeholder={field.placeholder}
              className="w-full text-sm border-gray-300 focus:ring-blue-500 focus:border-blue-500"
            />
          ) : (
            <Select
              id={field.key}
              value={filters[field.key] || ""}
              onChange={(e) => onFilterChange(field.key, e.target.value)}
              className="w-full text-sm bg-white border-gray-300 focus:ring-blue-500 focus:border-blue-500"
            >
              {field.options.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </Select>
          )}
        </div>
      ))}
    </FilterContainer>
  );
};

export default TableFilters;
